import { Icon, Button } from 'antd';
import { ssFormUtils } from '@bit/ui-common.ui-components/ss-utils';
import { login as config } from '../forms/formConfig';

const 
{ key } = config;

export default class Pending extends React.Component {
    constructor(props) { 
		super(props); 
		this.initFormState(); 
	}
    
    initState(config) {
    	
        let returnVal = {};
        Object.keys(config.formItems).map(key => {
        	if (key === 'password') {
				returnVal[`${key}`] = '';
				returnVal.id = undefined;
			}
        });
        
        return returnVal;
    }
    
    initFormState() {
    	
        let formConfig = {...config};
        for(let f in formConfig) {
            let config = formConfig[f];
        }
    }
    render() {
        const { services } = this.props;
        return (
            <div className='afsp-login-indicator-status-error'>
                <div style={{
                    position: 'absolute',
                    transform: 'translateX(-50%) translateY(-50%)',
                    left: '50%',
                    top: '40%',
                    width: '273px'
                }}>
                    <Icon type='exclamation-circle-o' style={{ fontSize: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        {'Invalid username and/or password.'}
                    </span>
                </div>
                <Button
                    size='small'
                    icon='rollback'
                    type='primary'
                    style={{ 
                        width: '120px', 
                        borderRadius: '20px',
                        position: 'absolute',
                        transform: 'translateX(-50%) translateY(-50%)',
                        left: '50%',
                        top: '70%'
                    }}
                    onClick={() => {
                        services.toggleAfspLoginStatusModal();
                        services.resetAfspLoginRequest();
                        services.storeForm(key, this.initState(config));
                    }}
                >
                    {'Retry'}
                </Button>
            </div>
        );
    }
}